<template lang="html">
  <div class="projectBasicContainer">
    <h1>檢視企業簽單</h1>
    <div class="tableContainer">
      <div class="fourColumn">
        <div class="title">下車時間</div>
        <div class="text">{{ order.getOffDate }}</div>
        <div class="title">上車地點</div>
        <div class="text">{{ order.pickUpLocation }}</div>
        <div class="title">部門</div>
        <div class="text">
          <Tag
            size="large"
            v-for="(department, idx) of order.employeeDepartment"
            :key="idx"
            >{{ department + " " }}</Tag
          >
        </div>
        <div class="title">下車地點</div>
        <div class="text">{{ order.dropOffLocation }}</div>
        <div class="title">姓名</div>
        <div class="text">
          <Tag
            size="large"
            v-for="(name, idx) of order.employeeName"
            :key="idx"
            >{{ name + " " }}</Tag
          >
        </div>
        <div class="title">廠區</div>
        <div class="text">
          <Tag
            size="large"
            v-for="(factory, idx) of order.employeeFactoryArea"
            :key="idx"
            >{{ factory + " " }}</Tag
          >
        </div>
        <div class="title">總金額</div>
        <div class="text">
          <span v-if="order.taxiFixedFare">
            {{ order.actualFare + order.serviceFare }}元 (固定車資：{{
              order.taxiFixedFare
            }}, 跳錶車資：{{ order.actualFare - order.taxiFixedFare }},
            服務費：{{ order.serviceFare }})
          </span>
          <span v-else>{{ order.actualFare + order.serviceFare }}元</span>
        </div>
        <div class="title">工號</div>
        <div class="text">
          <Tag
            size="large"
            v-for="(jobNumber, idx) of order.employeeJobNumber"
            :key="idx"
            >{{ jobNumber + " " }}</Tag
          >
        </div>
        <div class="title">簽單備註</div>
        <div class="text">{{ order.signingNote }}</div>
        <div class="title">乘客備註</div>
        <div class="text">{{ order.passengerNote }}</div>
        <div class="title">乘客簽名</div>
        <div class="text">
          <template v-for="(item, index) in order.employeeSigningImage">
            <img
              class="sign-small-img"
              v-if="item && item.includes('http')"
              :key="index"
              width="120"
              height="100"
              :src="item"
              alt="企業簽單圖片"
              @click="handleImg(item)"
            />
          </template>
        </div>
        <Modal v-model="imgModal" ok-text="確定" cancel-text="關閉"
          width="900">
          <img width="700" height="700" :src="modalImgSrc" alt="簽名圖檔" />
          <div slot="footer"></div>
        </Modal>
        <!-- <div class="title">異常備註</div> -->
        <!-- <div class="text order-abnormalNote">
          <template v-if="isEditingAbnormalNote">
            <Input v-model="order.abnormalNote" placeholder="請输入異常原因" ></Input>
            <div class="btnContainer btn-space">
              <Button type="success" @click="renewAbnormalNote">更新</Button>
              <Button @click="cancelEditing">取消編輯</Button>
            </div>
          </template>
          <div v-else>
            <span>{{ order.abnormalNote }}</span>
            <Button type="info" class="btn-left-space" @click="editing">編輯</Button>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="btnContainer">
      <Button :to="{name: 'OrderList'}">上一頁</Button>
    </div> -->
    <!-- <div>
      <h2>{{ timeStr }}</h2>
    </div> -->
    <!-- <div id="map" class="col-md-7" style="height: 950px;">
      Google map
    </div> -->
  </div>
</template>

<script>
import { webServer } from "@/utilities/api";
import API from "../asset/js/API";
import TeamAPI from "../asset/js/TeamAPI";
import jsCookie from "js-cookie";
import moment from "moment";
import dayjs from "dayjs";
import checkStateAndDirection from "../utilities/checkCarDirection";

export default {
  created() {
    webServer.defaults.headers.common["x-access-token"] = jsCookie.get("token");
    TeamAPI.defaults.headers.common["x-access-token"] = jsCookie.get("token");
    this.getSigningDetail();
  },
  mounted() {
    this.initMap();
  },
  data() {
    return {
      isEditingAbnormalNote: false,
      order: {},
      cloneOrder: {},
      map: null,
      lat: 25.0325917,
      lng: 121.5624999,
      points: [],
      markers: [],
      onMarker: null,
      offMarker: null,
      timeStr: "",
      imgModal: false,
      modalImgSrc: ""
    };
  },
  methods: {
    // 若是立即單或是預約單：提取司機時間為，order time or 預約時間
    // 路招單無法使用地圖
    initMap() {
      // this.map = new google.maps.Map(document.getElementById("map"), {
      //   center: { lat: this.lat, lng: this.lng },
      //   zoom: 15,
      //   maxZoom: 20,
      //   minZoom: 3,
      //   streetViewControl: false,
      //   mapTypeControl: false
      // });
    },
    handleImg(imgSrc) {
      this.imgModal = true;
      this.modalImgSrc = imgSrc;
    },
    getSigningDetail() {
      API.get(`/order/${this.$route.params.orderId}`)
        .then(res => {
          this.order = res.result;
          this.order.getOffDate = dayjs(res.result.getOffDate).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          if (res.result.onLocationGps !== null)
            // this.setOnLocationMarker(res.result.onLocationGps);

            this.getDrvierTrack(
              this.order.driverId,
              this.order.createdAt,
              this.order.orderTime,
              this.order.reservationTime
            );
        })
        .catch(err => {
          console.error("取得詳細企業簽單", err);
        });
    },
    setOnLocationMarker(gps) {
      if (this.onMarker !== null) this.onMarker.setMap(null);
      this.onMarker = new google.maps.Marker({
        position: {
          lat: gps.coordinates[1],
          lng: gps.coordinates[0]
        },
        map: this.map,
        icon: {
          url: checkStateAndDirection.responseOnMarker().img
        }
      });
    },
    getDrvierTrack(driverId, signCreatedTime, orderTime, reservationTime) {
      // 路招 ( createdAt - 3 hours ~ createdAt)
      let start = moment(signCreatedTime)
        .subtract(3, "hours")
        .format();
      let end = signCreatedTime;
      if (orderTime === null && reservationTime !== null) {
        // 預約 reservationTime ~ createdAt <= 3 hours ; createdAt - 3 hours ~ createdAt
        if (
          moment(start).isBefore(reservationTime) ||
          moment(start).isSame(reservationTime)
        ) {
          start = moment(reservationTime).format();
        }
      } else if (orderTime !== null && reservationTime === null) {
        // 立即 orderTime ~ createdAt <= 3 hours ; createdAt - 3 hours ~ createdAt
        if (
          moment(start).isBefore(orderTime) ||
          moment(start).isSame(reservationTime)
        ) {
          start = moment(orderTime).format();
        }
      } else {
        start = moment(signCreatedTime)
          .subtract(1, "hours")
          .format();
      }
      // let params = {
      //   startdate: start,
      //   enddate: moment(end).format()
      // };
      // this.timeStr = `${moment(start).format("YYYY-MM-DD HH:mm:ss")}~${moment(
      //   end
      // ).format("YYYY-MM-DD HH:mm:ss")}(最多搜尋簽單建立三個小時前的司機軌跡)`;
      // TeamAPI.get(`driver/${driverId}/trajectory`, { params })
      //   .then(res => {
      //     this.setMarker(res.result, signCreatedTime);
      //   })
      //   .catch(err => {
      //     console.error("取得詳細企業簽單", err);
      //   });
    },
    // renewAbnormalNote() {
    //   this.isEditingAbnormalNote = false;
    //   const putData = {
    //     abnormalNote: this.order.abnormalNote
    //   };
    //   EnterpriseAPI.put(
    //     `/enterprise/api/web/signing/${this.$route.params.orderId}/abnormal`,
    //     putData
    //   )
    //     .then(res => {
    //       console.log(res.result);
    //     })
    //     .catch(err => {
    //       console.error("更新企業簽單異常", err);
    //     });
    // },
    editing() {
      this.isEditingAbnormalNote = true;
      this.cloneOrder = { ...this.order };
    },
    cancelEditing() {
      this.isEditingAbnormalNote = false;
      this.order = { ...this.cloneOrder };
    },
    sortDataTime(data) {
      return data.sort((a, b) => {
        return new Date(a.time) - new Date(b.time);
      });
    }
    // setMarkerArray(driver_info, count, point) {
    //   let infowindow = new google.maps.InfoWindow({
    //     content: point.time
    //   });
    //   let numberMarkerImg = {
    //     url: checkStateAndDirection.checkCarDirectionOutputImage(
    //       driver_info.degrees,
    //       driver_info.status
    //     ).img,
    //     labelOrigin: new google.maps.Point(10, 25)
    //   };
    //   let marker = new google.maps.Marker({
    //     position: {
    //       lat: driver_info.latitude,
    //       lng: driver_info.longitude
    //     },
    //     label: String(count),
    //     map: this.map,
    //     labelAnchor: new google.maps.Point(25, 0),
    //     icon: numberMarkerImg
    //   });
    //   marker.addListener("click", function() {
    //     infowindow.open(map, marker);
    //   });
    //   this.markers.push(marker);
    // },
    // setMarker(data, signCreatedTime) {
    //   let count = 1;
    //   this.sortDataTime(data).forEach(driver_info => {
    //     var point = {
    //       lat: driver_info.latitude,
    //       lng: driver_info.longitude,
    //       status: driver_info.status,
    //       time: driver_info.time,
    //       speed: Math.round(driver_info.speed)
    //     };
    //     this.filterSignTimeToMarker(
    //       driver_info.time,
    //       signCreatedTime,
    //       driver_info
    //     );
    //     this.points.push(point);
    //     this.setMarkerArray(driver_info, count, point);
    //     count += 1;
    //   });
    //   if (data.length > 0) {
    //     this.map.setCenter({
    //       lat: data[0].latitude,
    //       lng: data[0].longitude
    //     });
    //   }
    // },
    // filterSignTimeToMarker(time, signCreatedTime, driverInfo) {
    //   let signSibtractTime = moment(signCreatedTime)
    //     .subtract(1, "minutes")
    //     .format();
    //   if (moment(time).isBetween(signSibtractTime, signCreatedTime)) {
    //     if (this.offMarker !== null) this.offMarker.setMap(null);
    //     let markerImg = {
    //       url: checkStateAndDirection.responseOffMarker().img,
    //       labelOrigin: new google.maps.Point(10, 25)
    //     };
    //     this.offMarker = new google.maps.Marker({
    //       position: {
    //         lat: driverInfo.latitude,
    //         lng: driverInfo.longitude
    //       },
    //       map: this.map,
    //       icon: markerImg
    //     });
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/components.scss";

.order-abnormalNote {
  .btn-space {
    margin-bottom: 0;
    margin-top: 10px;
  }

  .btn-left-space {
    margin-left: 8px;
  }
}

.sign-small-img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue